// extracted by mini-css-extract-plugin
module.exports = {"bulk_update_button":"BulkUpdateWorkOrderButton_bulk_update_button__243pG"};